module.exports = __webpack_public_path__ + "static/media/programma_python_dlya_prodvinutyh.d8f4c243.pdf";